export default __webpack_public_path__ + "static/media/agliveLogoLarge.784d8adb.png";